import React from "react";
import IconSvg, { IconSvgProps } from "~/guidelines/Icon/IconSvg";

const WarningLine = ({ color }: IconSvgProps) => {
  return (
    <IconSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.69803 19.5038C3.15803 19.5038 2.19803 17.8338 2.96803 16.5038L10.498 3.49378C11.268 2.16378 13.188 2.16378 13.958 3.49378L21.488 16.5038C22.258 17.8338 21.298 19.5038 19.758 19.5038H4.69803ZM19.758 17.5038L12.228 4.49378L4.69803 17.5038H19.758ZM11.228 9.50378V11.5038C11.228 12.0538 11.678 12.5038 12.228 12.5038C12.778 12.5038 13.228 12.0538 13.228 11.5038V9.50378C13.228 8.95378 12.778 8.50378 12.228 8.50378C11.678 8.50378 11.228 8.95378 11.228 9.50378ZM13.228 16.5038V14.5038H11.228V16.5038H13.228Z"
        fill="currentColor"
      />
    </IconSvg>
  );
};

export default WarningLine;
